import React, { useEffect } from "react";
import "../.././Reports.scss";
import {
  StockStatementDataType,
  TotalStockStatementDataType,
} from "../../../../redux/reports/reportsType";
import {
  currencySignAndNegativeValueAdjust,
  formatDate
} from "../../../../utils/commonFunctions";
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";

type AppProps = {
  stockStatementData: [] | StockStatementDataType[];
  totalStockStatementData: TotalStockStatementDataType;
  client_code: number;
  company_name?: any;
  start_date: string;
  end_date: string;
  currencySign: string | undefined;
};

const StockStatementTableData = ({
  stockStatementData,
  totalStockStatementData,
  client_code,
  company_name,
  start_date,
  end_date,
  currencySign,
}: AppProps) => {
  const [isEditOthersPresent, setIsEditOthersPresent] = useMenuCheck();
  const [isEditSalesPresent, setIsEditSalesPresent] = useMenuCheck();
  const [isEditExpensePresent, setIsEditExpensePresent] = useMenuCheck();

  useEffect(() => {
    setIsEditOthersPresent("Edit Others Invoicing Advanced", "menu");
    setIsEditSalesPresent("Edit Sales Invoicing Advanced", "menu");
    setIsEditExpensePresent("Edit Expense Invoicing Advanced", "menu");
    //eslint-disable-next-line
  }, []);

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", start_date);
    localStorage.setItem("end_date", end_date);
  };

  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  };

  const returnInvoiceType = (type: number) => {
    return (
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-filter-invoice">
            {type == 1
              ? "Expense"
              : type == 2
              ? "Sales"
              : type == 3
              ? "Others"
              : "Manufacturing Journal"}
          </Tooltip>
        }
      >
        <span
          className={
            type == 1
              ? "status-incomplete"
              : type == 2
              ? "status-complete"
              : type == 3
              ? "status-pending"
              : "manufacturing-journal"
          }
          style={{
            borderRadius: "50%",
            padding: type == 4 ? "5px 8px" : "5px 10px",
          }}
        >
          {type == 1 ? "E" : type == 2 ? "S" : type == 3 ? "O" : "M"}
        </span>
      </OverlayTrigger>
    );
  };

  const toFixedDecimalNumber = (data: number) => {
    return data === 0
      ? `${currencySign}0`
      : currencySignAndNegativeValueAdjust(
          currencySign,
          data ? data?.toFixed(2)?.toString() : "0"
        );
  };

  const renderEditIcon = (finalLink: string) => {
    return (
      <td>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 250 }}
          overlay={renderViewInvoiceToolTip}
        >
          <Link target="_blank" to={finalLink}>
            <span
              className="las la-pen"
              style={{
                fontSize: "20px",
                color: "#484848",
                background: "rgb(253 245 244)",
                padding: "8px",
                margin: "0px 0 0 3px",
                verticalAlign: "middle",
                cursor: "pointer",
              }}
            ></span>
          </Link>
        </OverlayTrigger>
      </td>
    );
  };

  const renderViewInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id={`button-send-email`} {...props}>
        View Invoice
      </Tooltip>
    );
  };

  //future Use
  // const toFixedDecimalNumber = (data: number) => {
  //   const comma= data === 0 ? 0 : data.toFixed(2)
  //   if(client_code!==(302||3197||184||880||907||331||909||881||382||906||371||320)){
  //     return numberWithCommas(comma)
  //   }else{
  //     return comma
  //   }
  // }

  const renderTotaldata = () => {
    return (
      <>
        <tr
          className="text-center"
          style={{ backgroundColor: "#d1d0cf", color: "white" }}
        >
          <td className="font-weight-bold text-dark">Total</td>
          <td></td>
          <td></td>
          <td></td>
          <td className="font-weight-bold text-dark">
            {totalStockStatementData?.total_inwards_qty}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalStockStatementData?.total_inwards_rate
                ? totalStockStatementData?.total_inwards_rate
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalStockStatementData?.total_inwards_value
                ? totalStockStatementData?.total_inwards_value
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td className="font-weight-bold text-dark">
            {totalStockStatementData?.total_outwards_qty}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalStockStatementData?.total_outwards_rate
                ? totalStockStatementData?.total_outwards_rate
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalStockStatementData?.total_outwards_value
                ? totalStockStatementData?.total_outwards_value
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </>
    );
  };
  const renderdata = () => {
    const stockStatementTableData = stockStatementData?.map((e: any) => {
      let finalLink =
        e?.invoice_type === 1 || e?.invoice_type === 2
          ? `/invoice-generation/edit/${e?.invoice_id}/${client_code}?type=${
              e?.invoice_type === 1 ? "expenses" : "revenues"
            }&client_code=${client_code}&company_name=${company_name}`
          : `/invoice-generation/edit-others/${client_code}/${e?.invoice_id}?type=others&client_code=${client_code}&company_name=${company_name}`;
      return (
        <>
          <tr className="text-center" key={e.date_of_invoice}>
            <td className="min-width">{formatDate(e.date_of_invoice)}</td>
            <td style={{ whiteSpace: "nowrap" }}>
              <Link
                className="pointer"
                target="_blank"
                to={finalRedirectLink}
                onClick={() => handleSetLocalStorageData(e?.ledger_id)}
                style={{
                  textDecoration: "underline",
                  color: "black",
                  fontWeight: "500",
                  textUnderlineOffset: "3px",
                }}
              >
                <span style={{ cursor: "pointer" }}>{e.ledger_name}</span>
              </Link>
            </td>
            <td>{e.document_no === "" ? "--/--" : e.document_no}</td>
            <td style={{ maxWidth: "50px" }}>
              {returnInvoiceType(e.invoice_type)}
            </td>
            <td className="text-nowrap" style={{ color: "#2080F6" }}>
              {e.inwards_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td className="min-width" style={{ color: "#2080F6" }}>
              {toFixedDecimalNumber(e.inwards_rate)}
            </td>
            <td
              className="min-width"
              style={{ color: "#2080F6", minWidth: "150px" }}
            >
              {toFixedDecimalNumber(e.inwards_value)}
            </td>
            <td className="text-nowrap" style={{ color: "#7fb913" }}>
              {e.outwards_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td className="min-width" style={{ color: "#7fb913" }}>
              {toFixedDecimalNumber(e.outwards_rate)}
            </td>
            <td
              className="min-width"
              style={{ color: "#7fb913", minWidth: "150px" }}
            >
              {toFixedDecimalNumber(e.outwards_value)}
            </td>
            <td className="text-nowrap">
              {e.closing_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td className="min-width">
              {toFixedDecimalNumber(e.closing_rate)}
            </td>
            <td className="min-width" style={{ minWidth: "150px" }}>
              {toFixedDecimalNumber(e.closing_value)}
            </td>
            {e?.invoice_type === 1 &&
              (isEditExpensePresent && e?.invoice_type === 1 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
            {e?.invoice_type === 2 &&
              (isEditSalesPresent && e?.invoice_type === 2 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
            {e?.invoice_type === 3 &&
              (isEditOthersPresent && e?.invoice_type === 3 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
            {
              e?.invoice_type === 4 && (
                <td></td>
              )
            }
          </tr>
        </>
      );
    });
    return stockStatementTableData;
  };
  return (
    <>
      {renderdata()}
      {renderTotaldata()}
    </>
  );
};

export default StockStatementTableData;
